import React from "react";
import { shiftCode, SHIFT_COLOR_COUNT } from "./shiftUtils";

const OVERRIDES = [
  { kind: "wo",      label: "–", title: "Weekly Off" },
  { kind: "leave",   label: "L", title: "Leave"       },
  { kind: "half",    label: "½", title: "Half Day"    },
  { kind: "working", label: "+", title: "Force On"    },
  { kind: "clear",   label: "✕", title: "Clear"       },
];

export default function RosterPalette({ shiftTemplates, paintBrush, onSelect }) {
  return (
    <div className="roster-palette">
      <span className="roster-palette-label">Paint</span>
      <div className="roster-palette-items">
        {shiftTemplates.map((shift, idx) => {
          const colorIndex = idx % SHIFT_COLOR_COUNT;
          const active = paintBrush?.kind === "shift" && paintBrush.shift.id === shift.id;
          return (
            <button
              key={shift.id}
              className={`roster-palette-shift range-color-${colorIndex}${active ? " is-active" : ""}`}
              onClick={() => onSelect(active ? null : { kind: "shift", shift })}
              title={`${shift.name} (${shift.workStartTime}–${shift.workEndTime})`}
            >
              {shiftCode(shift.name, shiftTemplates)}
              <span className="roster-palette-name">{shift.name}</span>
            </button>
          );
        })}
        {shiftTemplates.length > 0 && <div className="roster-palette-divider" />}
        {OVERRIDES.map(({ kind, label, title }) => {
          const active = paintBrush?.kind === kind;
          return (
            <button
              key={kind}
              className={`roster-palette-override palette-${kind}${active ? " is-active" : ""}`}
              onClick={() => onSelect(active ? null : { kind })}
              title={title}
            >
              <span>{label}</span>
              <span className="roster-palette-name">{title}</span>
            </button>
          );
        })}
      </div>
      {paintBrush ? (
        <button className="roster-palette-cancel" onClick={() => onSelect(null)}>
          ✕ Cancel <span className="roster-palette-hint">Esc</span>
        </button>
      ) : (
        <span className="roster-palette-hint">Select a type above to start painting</span>
      )}
    </div>
  );
}
